export const T = {
  en_GB: { invalidUrl: "Invalid YouTube URL", videoTitle: "YouTube video" },
  nb_NO: { invalidUrl: "Ugyldig YouTube-lenke", videoTitle: "YouTube-video" },
} as const;
